import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => {  
    
    var list = request({
        url: 'logOper/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 
//启用-禁用 
export const changeStatus = query => {  
    var list = request({
        url: 'logOper/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
//添加渠道信息
export const saveForm = query => {  
    var list = request({
        url: 'logOper/insert.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const handDelete = query => {  
    var list = request({
        url: 'logOper/delete.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeForm = query => {  
    var list = request({
        url: 'logOper/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};


export const fetchSelect = query => {  
    var list = request({
        url: 'logOper/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

